import React, { useState, useEffect } from "react";
import {
  Nav,
  Button,
  Offcanvas,
  Spinner,
  Container,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { logout } from "../../../features/auth/authActions";
import Api from "../../components/api/Api";
import {
  FaUser,
  FaUserEdit,
  FaLock,
  FaFileUpload,
  FaCreditCard,
  FaSignOutAlt,
  FaBars,
} from "react-icons/fa";
import Style from "../../UserStyle.module.css";
import "./UserProfile.css";

const UserProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const loggedInUser = useSelector((state) => state.auth.user);
  const userId = loggedInUser?.userDetails?.id;

  const [userDetail, setUserDetails] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showSidebar, setShowSidebar] = useState(false);

  const logoutHandler = async () => {
    try {
      dispatch(logout());
      navigate("/login");
    } catch (error) {
      console.log(error);
    }
  };

  const getDetailsApi = Api({
    url: `admin/user/id/${userId}`,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const responseData = await getDetailsApi.fetchData();
        setUserDetails(responseData?.data?.user);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();

    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navItems = [
    { label: "Profile", path: "/user/profile", icon: <FaUser /> },
    { label: "Edit Profile", path: "/user/edit-profile", icon: <FaUserEdit /> },
    // { label: "Change Password", path: `/changepassword/${userId}`, icon: <FaLock /> },
    { label: "Documents", path: `/user/upload-documents`, icon: <FaFileUpload /> },
    { label: "Payment", path: `/user/payment-details`, icon: <FaCreditCard /> },
    { label: "Logout", action: logoutHandler, icon: <FaSignOutAlt />, color: "red" },
  ];

  const renderSidebar = () => (
    <nav className="sidebar-container">
      <Nav className="flex-column w-100 px-2">
        {navItems.map((item, idx) => {
          const isActive = location.pathname === item.path;
          const isLogout = item.label === "Logout";
          return (
            <Nav.Item key={idx} className="mb-1">
              {item.path ? (
                <Nav.Link
                  as={Link}
                  to={item.path}
                  className={`sidebar-link d-flex align-items-center gap-3 ${
                    isActive ? "active" : ""
                  }`}
                >
                  <span
                    className={`sidebar-icon ${
                      isLogout ? "text-danger" : ""
                    }`}
                  >
                    {item.icon}
                  </span>
                  <span
                    className={`sidebar-label ${
                      isLogout ? "text-danger" : ""
                    }`}
                  >
                    {item.label}
                  </span>
                </Nav.Link>
              ) : (
                <Nav.Link
                  onClick={item.action}
                  className="sidebar-link d-flex align-items-center gap-3 logout-link"
                >
                  <span className="sidebar-icon text-danger">{item.icon}</span>
                  <span className="sidebar-label text-danger">{item.label}</span>
                </Nav.Link>
              )}
            </Nav.Item>
          );
        })}
      </Nav>
    </nav>
  );

  return (
    <>
      {isLoading ? (
        <div className={Style.spinner}>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <Container fluid className="p-3">
          {/* Mobile Toggle */}
          {isMobile && (
            <Button
              variant="light"
              className="mb-3 d-flex align-items-center gap-2"
              onClick={() => setShowSidebar(true)}
            >
              <FaBars />
            </Button>
          )}

          {/* Desktop Sidebar */}
          {!isMobile && renderSidebar()}

          {/* Mobile Offcanvas */}
          {isMobile && (
            <Offcanvas
              show={showSidebar}
              onHide={() => setShowSidebar(false)}
              placement="start"
            >
              <Offcanvas.Header closeButton>
              </Offcanvas.Header>
              <Offcanvas.Body>{renderSidebar()}</Offcanvas.Body>
            </Offcanvas>
          )}
        </Container>
      )}
    </>
  );
};

export default UserProfile;
